export default __webpack_public_path__ + "static/professional-training-upskill-23313eede035d564351e23f8e0245d27.png";